/* eslint-disable */
<template>
  <v-card v-resize="onResize">
    <v-app-bar
      absolute
      color="white"
      elevation="0"
      scroll-target="#scrolling-techniques-7"
    >
      <v-checkbox
        v-model="selectAll"
        :label="numberSelected"
        @click.stop="selectAllTeam"
        :indeterminate="indeterminate"
        hide-details
      ></v-checkbox>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="primary"
      ></v-progress-linear>

      <v-spacer></v-spacer>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            small
            v-bind="attrs"
            v-on="on"
            color="red"
            @click="sendExport"
          >
            <v-icon>mdi-email</v-icon>
          </v-btn>
        </template>
        <span>Email List</span>
      </v-tooltip>
    </v-app-bar>

    <v-sheet
      v-resize="onResize"
      :height="height"
      id="scrolling-techniques-7"
      class="overflow-y-auto"
    >
      <v-container style="margin-top: 70px; margin-bottom: 70px; padding: 0;">
        <v-card class="mx-auto" outlined>
          <v-virtual-scroll
            :bench="benched"
            :items="showCompanies"
            :height="height"
            item-height="64"
          >
            <template v-slot:default="{ item }">
              <v-list-item :key="item.id" :class="item.lastDraw">
                <v-list-item-action>
                  <v-checkbox v-model="item.selected"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }} - <strong>{{ item.status }}</strong>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <div>
                    <v-chip
                      class="ma-2"
                      color="primary"
                      v-if="item.drawsYear === 4"
                    >
                      Quarterly
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="green"
                      text-color="white"
                      v-if="item.drawsYear === 12"
                    >
                      Monthly
                    </v-chip>
                    <v-btn icon :to="`company/${item.id}`">
                      <v-icon color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-container>
    </v-sheet>

    <v-dialog v-model="loading1" fullscreen>
      <v-container
        fluid
        fill-height
        style="background-color: rgba(255, 255, 255, 0.5);"
      >
        <v-layout justify-center align-center>
          <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="primary"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import _ from 'lodash'
import Api from '@/services/Api'

import moment from 'moment'

export default {
  data() {
    return {
      benched: 0,
      currentPage: 'Dashboard',
      contentHeight: 0,
      height: 400,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dialog: false,
      viewDialog: false,
      messages: [],
      selected: {},
      drawList: [],
      companies: [],
      showCompanies: [],
      indeterminate: false,
      loading: true,
      loading1: false,
      numberSelected: 'Select All',
      search: '',
      selectAll: true,
      snackbar: {
        show: false,
        color: '',
        message: '',
      },
    }
  },

  created() {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.loading = false
    // this.getCompanies()
  },

  mounted() {
    this.onResize()
  },

  watch: {
    showCompanies: {
      // eslint-disable-next-line
      handler: function (val, oldVal) {
        // this.loading = true
        this.selected = _.filter(this.showCompanies, ['selected', true])

        const notSelected = _.filter(this.showCompanies, ['selected', false])

        if (this.selected === undefined || this.selected.length == 0) {
          this.indeterminate = false
          this.selectAll = false
        } else {
          if (notSelected === undefined || notSelected.length == 0) {
            this.selectAll = true
          } else {
            this.selectAll = false
          }

          if (!this.selectAll) {
            this.indeterminate = true
          }
        }

        if (this.selected.length > 0) {
          this.numberSelected = '(' + this.selected.length + ' selected)'
          this.disable = false
        } else {
          this.numberSelected = 'Select All'
          this.disable = true
        }

        this.loading = false
      },
      deep: true,
    },
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 120
    },

    async getCompanies() {
      let startMonth = 0
      const clientId = this.$store.state.client.id
      let today = moment().format('D')
      today = parseInt(today)
      let month = moment().format('M')
      // let month = 7
      month = parseInt(month)
      console.log('today', today)

      if (month > 3 && month < 7) {
        startMonth = month - 3
      } else if (month > 6 && month < 10) {
        startMonth = month - 6
      } else if (month > 9) {
        startMonth = month - 9
      } else {
        startMonth = month
      }
      console.log('startMonth', startMonth)

      try {
        const response = await Api().get('companies_calendar/' + clientId)

        const companies = response.data
        console.log(companies)

        for (let i in companies) {
          if (
            companies[i].dueDate === today &&
            companies[i].startMonth === startMonth
          ) {
            if (companies[i].CompanyDraws.length > 0) {
              for (let j in companies[i].CompanyDraws) {
                if (companies[i].CompanyDraws[j].status === 'Pending') {
                  companies[i].status = 'Pending'
                }
              }
            }

            companies[i].selected = true
            this.drawList.push(companies[i])
          }
        }

        this.showCompanies = this.drawList
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },

    async sendExport() {
      this.loading1 = true
      try {
        console.log('companies', this.selected)
        let formData = {}
        formData.companies = this.selected
        formData.userId = this.$store.state.user.id

        const response = await Api().post('send_lists/', formData)

        this.loading1 = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    selectAllTeam() {
      if (this.indeterminate) {
        this.indeterminate = false
        this.selectAll = true
      }

      for (var i in this.showCompanies) {
        this.showCompanies[i].selected = this.selectAll
      }
    },
  },
}
</script>

<style scoped></style>
